import { post } from '../../api/api';

export const updateAiJobDescriptionLog = async (aiJobDescriptionLog: AiJobDescriptionLog) =>
  post(`/ai-job-description-log/${aiJobDescriptionLog.aiJobDescriptionLogId}`, {
    body: JSON.stringify(aiJobDescriptionLog),
  });
